import {applyMiddleware, compose, createStore} from "redux";
import rootReducer from "./rootReducer";
import createSagaMiddleware from 'redux-saga';

import rootSaga from './rootSaga';
import {hideGlobalLoader, showGlobalLoader} from "./ducks/global-loader";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

const testeMiddleware = store => next => action => {
  next(action);
  if (action.showGlobalLoader) {
    store.dispatch(showGlobalLoader(action.message));
  }

  if (action.hideGlobalLoader) {
    store.dispatch(hideGlobalLoader());
  }

};

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(sagaMiddleware, testeMiddleware)
  )
);

sagaMiddleware.run(rootSaga);

export default store;
